import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'calender-progress-bar',
  template: `
    <svg class="round-progress" width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="15" stroke="#E1E1E1" stroke-width="8" fill="none" />
      <circle
        *ngIf="progress > 0"
        [attr.stroke]="color"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="calculateDashArray()"
        stroke-dashoffset="0"
        [attr.stroke-linecap]="roundedCorners ? 'round' : 'butt'"
        cx="25"
        cy="25"
        r="15"
        transform="rotate(-90 25 25)"
        fill="none"
      ></circle>
    </svg>
  `,
  styles: [
    `
      .round-progress {
        width: 50px;
        height: 50px;
      }
    `,
  ],
})
export class DailyProgressBarComponent implements AfterViewInit {
  @Input() progress: number = 0;
  @Input() color: string = '#E6A43D';
  @Input() strokeWidth: number = 8;
  @Input() roundedCorners: boolean = true;

  calculateDashArray(): string {
    const circumference = 2 * Math.PI * 15;
    const progressOffset = (circumference * this.progress) / 100;
    return `${progressOffset} ${circumference}`;
  }

  ngAfterViewInit(): void {}
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/components/calender-progress-bar.component.ts